import React from 'react';
import { Helmet } from 'react-helmet-async';

interface MetaDataProps {
    title: string;
    description: string;
    name?: string;
    type?: string;
    keywords?: string;
    canonicalUrl?: string;
    ogImage?: string;
    ogUrl?: string;
    twitterCard?: 'summary' | 'summary_large_image' | 'app' | 'player';
    twitterSite?: string;
    structuredData?: object;
    lang?: string;
    robots?: string;
}

export const MetaData = ({
	title,
	description,
	type = 'website',
	keywords,
	canonicalUrl,
	ogImage,
	ogUrl,
	twitterCard = 'summary_large_image',
	twitterSite,
	structuredData,
	lang = 'en',
	robots = 'index, follow'
}: MetaDataProps) => {

	return(
		<Helmet>
			<html lang={lang} />
			<title>{title}</title>
			<meta name="description" content={description} />
			{keywords && <meta name="keywords" content={keywords} />}
			<meta name="robots" content={robots} />
			
			{canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
			
			{/* Open Graph / Facebook */}
			<meta property="og:type" content={type} />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			{ogImage && <meta property="og:image" content={ogImage} />}
			{ogUrl && <meta property="og:url" content={ogUrl} />}
			<meta property="og:site_name" content="Loop" />
			
			{/* Twitter */}
			<meta name="twitter:card" content={twitterCard} />
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			{twitterSite && <meta name="twitter:site" content={twitterSite} />}
			{ogImage && <meta name="twitter:image" content={ogImage} />}
			
			{/* Structured Data */}
			{structuredData && (
				<script type="application/ld+json">
					{JSON.stringify(structuredData)}
				</script>
			)}
		</Helmet>
	);
};